var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoMes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "84s9wcokca"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15381",
    transform: "translate(722 1477)",
    style: {
      fill: "#ff1010",
      opacity: 0.43
    },
    d: "M0 0h120v120H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 677",
    transform: "translate(-722 -1477)",
    style: {
      clipPath: "url(#84s9wcokca)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 60",
    transform: "translate(808.59 1496.912)",
    style: {
      strokeWidth: 2,
      strokeMiterlimit: 10,
      stroke: "#4cbbb8",
      fill: "none"
    },
    d: "M0 0h11.499"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59460",
    d: "M12.1 1.754h54.48v11.038H15.4",
    transform: "translate(742.007 1489.643)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#fff",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59462",
    d: "M50.964 4.295a6.275 6.275 0 1 1-8.682-1.846 6.275 6.275 0 0 1 8.682 1.846z",
    transform: "translate(779.919 1489.203)",
    style: {
      strokeWidth: 2,
      strokeMiterlimit: 10,
      stroke: "#4cbbb8",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15375",
    width: 76.179,
    height: 8.738,
    rx: 2,
    transform: "translate(727 1575.988)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#fff",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15376",
    d: "M3 0h44.287a3 3 0 0 1 3 3v12.582h0H0h0V3a3 3 0 0 1 3-3z",
    transform: "translate(739.946 1560.406)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#fff",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59463",
    d: "M25.528 18.382v29.3H14.49v-29.3",
    transform: "translate(745.316 1512.717)",
    style: {
      stroke: "#fff",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 61",
    transform: "translate(825.62 1502.434)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 2
    },
    d: "M0 0v16.181"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 62",
    transform: "translate(825.62 1502.434)",
    style: {
      strokeWidth: 2,
      strokeMiterlimit: 10,
      stroke: "#4cbbb8",
      fill: "none"
    },
    d: "M0 0v16.181"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59465",
    d: "M37.288 20.169v-7.015h22.759v7.015",
    transform: "translate(776.953 1505.461)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#4cbbb8",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59466",
    d: "M12.19 4.145A2.186 2.186 0 1 1 9.165 3.5a2.189 2.189 0 0 1 3.025.642",
    transform: "translate(736.547 1491.578)",
    style: {
      fill: "#4cbbb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59467",
    d: "M19.905 16.025a2.186 2.186 0 1 1-3.025-.642 2.189 2.189 0 0 1 3.025.642",
    transform: "translate(747.253 1508.063)",
    style: {
      fill: "#4cbbb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 63",
    transform: "translate(745.466 1504.832)",
    style: {
      stroke: "#fff",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M11.946 18.395 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 64",
    transform: "translate(754.766 1498.885)",
    style: {
      stroke: "#fff",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "m0 0 12 18.478"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 84",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(768 1565)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 85",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(775 1565)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 86",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(782 1565)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59464",
    d: "M29.315 20.545A7.914 7.914 0 1 1 21.4 12.63a7.915 7.915 0 0 1 7.915 7.915z",
    transform: "translate(743.925 1504.734)",
    style: {
      strokeWidth: 2,
      strokeMiterlimit: 10,
      stroke: "#4cbbb8",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59461",
    d: "M20.324 4.355A7.914 7.914 0 1 1 9.376 2.027a7.913 7.913 0 0 1 10.948 2.328z",
    transform: "translate(733.218 1488.248)",
    style: {
      strokeWidth: 2,
      strokeMiterlimit: 10,
      stroke: "#4cbbb8",
      fill: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMes);
export default __webpack_public_path__ + "static/media/ico_mes.cc1ea1967f67bfbc71159f6af9c25892.svg";
export { ForwardRef as ReactComponent };